export function logError(scope, error) {
  console.error(`[${scope}]`, error);
}
